import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { ROUTES } from '@router/modules/constants'

export default {
  logoutForExpiredToken () {
    store.dispatch('setActive', true)
    localStorage.removeItem('access_token')
    localStorage.removeItem('permission')
    localStorage.removeItem('user')
    store.dispatch('setPermission', '')
  },
  logout () {
    store.dispatch('setActive', true)
    const token = localStorage.getItem('access_token')
    localStorage.removeItem('access_token')
    localStorage.removeItem('permission')
    localStorage.removeItem('user')
    store.dispatch('setUser', null)
    store.dispatch('setIsJiraAuth', false)
    store.dispatch('setPermission', '')
    router.push(ROUTES.SIGN_IN.name)

    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/api/auth/logout',
        headers: {
          Authorization: 'Bearer' + token
        }
      })
        .then(response => {
          resolve(true)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  authUser () {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/api/authUser',
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      })
        .then(response => {
          const user = response.data
          store.dispatch('setUser', user)
          store.dispatch('setUserRoles', user.roles)
          store.dispatch('setUserName', user.name)
          store.dispatch('setUserId', user.id)
          resolve(user)
        })
        .catch(err => {
          if (err.response) {
            this.$snotify.error(
              err.response.data.error,
              'Error',
              this.$store.state.snotify
            )
          }
        })
    })
  }
}
